// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Configuração do Firebase
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC-2gaC8U6X-ZcGUWyhHncgxJMhdmCavig",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "mvcc-a3d60.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "mvcc-a3d60",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "mvcc-a3d60.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "653857302186",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:653857302186:web:15368d578187f52d1fd2d3"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar Firebase Authentication
export const auth = getAuth(app);
export default app;

